import axios from 'axios'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export function requestProgramsData() {
	return {
		type: 'REQUEST_PROGRAMS_DATA'
	}
}

export function receiveProgramsData( data ) {
	return {
		type: 'RECEIVE_PROGRAMS_DATA',
		payload: data
	}
}

export function getProgramsData() {
	return function( dispatch ) {
		return axios({
				url: siteData.api_base_url + 'programs',
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then( function( response ) {
				dispatch( receiveProgramsData( response.data ) )
			})
			.catch( function( error ) {
				console.log( error, 'error' );
			})
	}
}

export function setProgramsFilterSearch( value ) {
	return {
		type: 'SET_PROGRAMS_FILTER_SEARCH',
		payload: value
	}
}

export function setProgramsFilterCategory( value ) {
	return {
		type: 'SET_PROGRAMS_FILTER_CATEGORY',
		payload: value
	}
}

export function setProgramsFilterPodcasts( value ) {
	return {
		type: 'SET_PROGRAMS_FILTER_PODCASTS',
		payload: value
	}
}
